<template>
  <a-drawer
      :visible="visible"
      :title="title"
      width="720px"
      placement="right"
      @close="onClose">
    <a-spin :spinning="loading">
      <a-table
          :columns="columns"
          rowKey="id"
          :pagination="paginationConfig"
          :data-source="runs"
          @change="onTableChange"
          size="small">
        <template slot="status" slot-scope="text, record">
          <a-tag :color="statusColor(record.status)">{{ record.status }}</a-tag>
          <small v-if="record.skipped_reason">{{ record.skipped_reason }}</small>
        </template>
        <template slot="ran_at" slot-scope="text, record">
          {{ formatDateTime(record.ran_at) }}
        </template>
        <template slot="counts" slot-scope="text, record">
          <span :title="$t('firmware_schedules.col_counts')">
            {{ record.bases_succeeded_count }} / {{ record.bases_targeted_count }}
            <span v-if="record.bases_failed_count" style="color: #ff5d53;">
              ({{ record.bases_failed_count }} failed)
            </span>
          </span>
        </template>
        <template slot="notes" slot-scope="text, record">
          <a-popover v-if="record.notes" :title="$t('firmware_schedules.col_notes')" trigger="click">
            <template slot="content">
              <pre style="max-width:400px; white-space:pre-wrap;">{{ record.notes }}</pre>
            </template>
            <a-button size="small">{{ $t('basics.view') }}</a-button>
          </a-popover>
          <span v-else style="color:#999;">-</span>
        </template>
      </a-table>
    </a-spin>
  </a-drawer>
</template>

<script>
import { formatDateTime } from '@/utils/helpers/dateFormat';
import { i18n } from '@/i18n';

const columns = [
  { title: i18n.t('firmware_schedules.col_run_at'), key: 'ran_at', scopedSlots: { customRender: 'ran_at' } },
  { title: i18n.t('firmware_schedules.col_run_status'), key: 'status', scopedSlots: { customRender: 'status' } },
  { title: i18n.t('firmware_schedules.col_counts'), key: 'counts', scopedSlots: { customRender: 'counts' } },
  { title: i18n.t('firmware_schedules.col_notes'), key: 'notes', width: 90, scopedSlots: { customRender: 'notes' } }
];

export default {
  name: 'FirmwareScheduleRunHistory',
  props: {
    visible: { type: Boolean, default: false },
    schedule: { type: Object, default: null }
  },
  data() {
    return {
      formatDateTime,
      columns,
      loading: false,
      runs: [],
      pageNumber: 1,
      pageSize: 25,
      total: 0
    };
  },
  computed: {
    title() {
      return this.schedule
          ? this.$t('firmware_schedules.history_for', { name: this.schedule.name })
          : this.$t('firmware_schedules.history');
    },
    paginationConfig() {
      return {
        current: this.pageNumber,
        pageSize: this.pageSize,
        total: this.total,
        showSizeChanger: false
      };
    }
  },
  watch: {
    visible(v) {
      if (v && this.schedule) {
        this.pageNumber = 1;
        this.fetch();
      } else {
        this.runs = [];
      }
    }
  },
  methods: {
    fetch() {
      if (!this.schedule) return;
      this.loading = true;
      this.$store.dispatch('firmwareSchedules/FetchRuns', {
        id: this.schedule.id,
        params: { page: this.pageNumber, per_page: this.pageSize }
      }).then(response => {
        this.runs = response.data || [];
        this.total = response.meta ? response.meta.total : this.runs.length;
      }).finally(() => { this.loading = false; });
    },
    onTableChange(pagination) {
      this.pageNumber = pagination.current;
      this.fetch();
    },
    onClose() {
      this.$emit('close');
    },
    statusColor(status) {
      const map = { success: 'green', partial: 'orange', skipped: 'blue', failed: 'red' };
      return map[status] || 'default';
    }
  }
};
</script>
